<template>
  <div id="settings-wrapper">
    <v-card
      id="settings"
      class="py-2 px-4"
      color="rgba(0, 0, 0, .3)"
      dark
      flat
      link
      min-width="100"
      style="position: fixed; top: 115px; right: -35px; border-radius: 8px;"
    >
      <v-icon size="40">mdi-menu-{{ !menu ? 'left' :'right' }}</v-icon>
    </v-card>

    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      activator="#settings"
      bottom
      content-class="v-settings"
      left
      light
      nudge-left="8"
      offset-x
      origin="top right"
      transition="scale-transition"
    >
      <v-card class="text-center" width="300">
        <v-card-title class="justify-center">Configuracion</v-card-title>

        <v-card-text>
          <v-divider class="my-4 secondary" />
          <strong class="mb-3 d-inline-block">Idioma</strong>

          <v-item-group>
            <v-item color="success">
              <v-btn text value="left" @click.prevent="UpdateLang('es')">ES</v-btn>
            </v-item>

            <v-btn text value="center" @click.prevent="UpdateLang('en')">EN</v-btn>
          </v-item-group>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
// Mixins
import Proxyable from "vuetify/lib/mixins/proxyable";
import { mapMutations, mapState } from "vuex";

export default {
  name: "DashboardCoreSettings",

  mixins: [Proxyable],

  data: () => ({
    color: "#E91E63",
    text: "center",
    colors: ["#9C27b0", "#00CAE3", "#4CAF50", "#ff9800", "#E91E63", "#FF5252"],
    image:
      "https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg",
    images: [
      "https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg",
      "https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-2.jpg",
      "https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-3.jpg",
      "https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-4.jpg"
    ],
    menu: false,
    saveImage: "",
    scrim: "rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)",
    scrims: [
      "rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)",
      "rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)",
      "rgba(244, 67, 54, .8), rgba(244, 67, 54, .8)"
    ],
    showImg: true
  }),

  computed: {
    ...mapState(["barImage"])
  },

  watch: {
    color(val) {
      this.$vuetify.theme.themes.light.primary = val;
    },
    showImg(val) {
      if (!val) {
        this.saveImage = this.barImage;
        this.setBarImage("");
      } else if (this.saveImage) {
        this.setBarImage(this.saveImage);
        this.saveImage = "";
      } else {
        this.setBarImage(val);
      }
    },
    image(val) {
      this.setBarImage(val);
    },
    scrim(val) {
      this.$store.commit("SET_SCRIM", val);
    }
  },

  methods: {
    ...mapMutations({
      setBarImage: "SET_BAR_IMAGE"
    }),
    UpdateLang(Lang) {
      console.log(Lang);

      this.$store.dispatch("_SET_LANGUAGE", Lang);
      this.$i18n.locale = Lang;
    }
  }
};
</script>

<style lang="sass">
  .v-settings
    .v-item-group > *
      cursor: pointer

    &__item
      border-width: 3px
      border-style: solid
      border-color: transparent !important

      &--active
        border-color: #00cae3 !important
</style>
